const RICOS_VERSION = "10.126.0";
export {
  RICOS_VERSION
};
//# sourceMappingURL=version.js.map
